

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

export const SortableTableHeader = ({ columnName, displayName, handleSort, sort_by, sort_order, active }) => {
    const getSortIcon = () => {
        if (sort_by === columnName) {
            return sort_order === 'asc' ? faSortUp : faSortDown;
        }
        return null;
    };

    const sortIcon = active ? getSortIcon() : null;

    return (
        <th
            onClick={() => active && handleSort(columnName)}
            onKeyDown={(e) => {
                if (active && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    handleSort(columnName);
                }
            }}
            style={{ cursor: active ? 'pointer' : 'default' }}
            role={active ? "button" : undefined}
            tabIndex={active ? 0 : undefined}
            aria-sort={
                sort_by === columnName
                    ? sort_order === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            }
        >
            <div className="d-flex align-items-center">
                <span className={active ? "sortable-text" : undefined}>{displayName}</span>
                {sortIcon && <FontAwesomeIcon icon={sortIcon} style={{ marginLeft: '7px' }} />}
            </div>
        </th>
    );
};

export const SortableTableHeaderNew = ({ column }) => {
    const { isSorted, isSortedDesc, getSortByToggleProps, render } = column;

    const getSortIcon = () => {
        if (isSorted) {
            return isSortedDesc ? faSortDown : faSortUp;
        }
        return null;
    };

    return (
        <th
            {...getSortByToggleProps()}
            style={{
                cursor: 'pointer',
                position: 'sticky',
                top: 0,
                backgroundColor: '#f2f2f2', // Set your desired background color
                zIndex: 1, // Ensure the header stays above the table body
                borderBottom: '1px solid #ddd',
                padding: '8px',
                textAlign: 'left',
            }}
        >
            <div className="d-flex align-items-center">
                <span>{render('Header')}</span>
                {getSortIcon() && (
                    <FontAwesomeIcon icon={getSortIcon()} style={{ marginLeft: '7px' }} />
                )}
            </div>
        </th>
    );
};